import React, { useEffect, useState } from 'react'
import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box, SegmentedControl, Sheet } from '@node-space/ui-components'
import { contactInstrumentActionAtom } from 'pages/Contacts/atoms/contactAtoms'
import { InstrumentType } from 'types/contacts'
import { ContactInstrumentForm } from '../ContactInstrumentForm'
import { ContactFiatInstrumentForm } from './FiatInstrument/FiatInstrument'

interface AddAccountSheetProps {
  isSheetOpen: boolean
  onCryptoTabSelected?: () => void
}

export const AddAccountSheet = ({ isSheetOpen, onCryptoTabSelected }: AddAccountSheetProps) => {
  const { t } = useTranslation()
  const [accountType, setAccountType] = useState<InstrumentType>(InstrumentType.BANK_ACCOUNT)
  const [contactInstrumentAction, setContactInstrumentAction] = useAtom(contactInstrumentActionAtom)

  const { onBack, onClose, subHeader, meta } = contactInstrumentAction || {}
  const flowType = meta?.flowType

  const effectiveAccountType = flowType || accountType

  const showSegmentedControl = !flowType && !onBack

  const getSheetHeader = () => {
    if (flowType === InstrumentType.CRYPTO) return t('contacts.addCryptoAddress')
    if (flowType) return t('contacts.addBankAccount')
    return t('contacts.addBankAccountOrCryptoAddress')
  }

  useEffect(() => {
    if (!isSheetOpen) {
      setAccountType(InstrumentType.BANK_ACCOUNT)
    }
  }, [isSheetOpen])

  const handleTabChange = (value: string) => {
    if (value === InstrumentType.CRYPTO) {
      onCryptoTabSelected?.()
    }
    setAccountType(value as InstrumentType)
    setContactInstrumentAction({
      ...contactInstrumentAction,
      onBack: undefined,
      subHeader: undefined,
    })
  }

  return (
    <Sheet
      header={getSheetHeader()}
      onBack={onBack}
      isOpen={isSheetOpen}
      onClose={onClose}
      subHeader={subHeader}
    >
      <Box flexCol width="full">
        {showSegmentedControl && (
          <Box paddingT={24}>
            <SegmentedControl
              name="add-account-type"
              value={accountType}
              onChange={handleTabChange}
              aria-label={t('contacts.addBankAccountOrCryptoAddress')}
            >
              <SegmentedControl.Item
                value={InstrumentType.BANK_ACCOUNT}
                label={t('contacts.addBankAccount')}
              />
              <SegmentedControl.Item
                value={InstrumentType.CRYPTO}
                label={t('contacts.addCryptoAddress')}
              />
            </SegmentedControl>
          </Box>
        )}
        {effectiveAccountType === InstrumentType.BANK_ACCOUNT ? (
          <ContactFiatInstrumentForm />
        ) : (
          <ContactInstrumentForm />
        )}
      </Box>
    </Sheet>
  )
}
